import type { WebsocketMessage } from './provider.jsx'
import type { Metric as NavigationMapMetric } from '@mission.io/navigation-map-client'

type Metric = NavigationMapMetric

/**
 * getMetricsWebsocketMessage - get a websocket message which will add metrics to mission metrics
 *
 * @param {Array<Metric>} metricsToSend - the metrics to add to the mission metrics
 *
 * @return {WebsocketMessage} the message to send over the websocket
 */
export function getMetricsWebsocketMessage(
	metricsToSend: Array<Metric>
): WebsocketMessage {
	return {
		type: 'NOTE_OWNER_MISSION_METRIC',
		payload: { metrics: metricsToSend },
	}
}
